import classNames from "classnames";
import { useRef } from "react";

type ColorSwatchProps = {
	color: string;
	onChange: (color: string) => void;
	isCompact?: boolean;
};

const ColorSwatch = ({ color, onChange, isCompact = false }: ColorSwatchProps) => {
	const inputRef = useRef<HTMLInputElement>(null);

	return (
		<div
			className={classNames("relative cursor-pointer", isCompact ? "px-2 h-6" : "px-4 h-8")}
			style={{ backgroundColor: color }}
			onClick={() => inputRef.current?.click()}
		>
			<input
				ref={inputRef}
				type="color"
				className="absolute bottom-0 right-0 w-0 h-0 opacity-0 pointer-events-none"
				style={{ colorScheme: "dark" }}
				value={color}
				onChange={(e) => onChange(e.target.value)}
			/>
		</div>
	);
};

export default ColorSwatch;
